/* Outdoors Nordic. Flyttad ur snippets/on-bogo-guard.liquid 2026-10-07.
   Lag inline och skickades med varje sidvisning som anvande sektionen.
   Laddas som modul: samma URL evalueras en gang oavsett antal taggar. */

(function () {
  'use strict';
function las(id) {
var el = document.getElementById(id);
if (!el) return null;
try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
var FAM = las('on-bogo-families'), S = las('on-bogo-strings');
  if (!FAM || !FAM.pairs || !S) return;
  var VM = las('on-bogo-variants') || {};
/* AUKTORITET: produkt-id -> familj + sida. Kommer fran metafaltet. */
  var P = {}, harInaktiv = false, famNycklar = {};
  FAM.pairs.forEach(function (p) {
if (p.active === false) harInaktiv = true;
famNycklar[p.key] = 1;
P[String(p.n)] = { key: p.key, sida: 'normal', p: p };
P[String(p.o)] = { key: p.key, sida: 'offer', p: p };
  });
/* CACHE: variant-id -> familj + sida. Bara snabbvag. */
  var V = {}, cacheOk = true;
  Object.keys(famNycklar).forEach(function (k) { if (!VM[k]) cacheOk = false; });
  Object.keys(VM).forEach(function (k) { if (!famNycklar[k]) cacheOk = false; });
  if (cacheOk) {
FAM.pairs.forEach(function (p) {
(VM[p.key] || []).forEach(function (r) {
 V[String(r[0])] = { key: p.key, sida: 'normal', p: p };
 V[String(r[1])] = { key: p.key, sida: 'offer', p: p };
});
});
  } else if (window.console && console.warn) {
console.warn('[on-bogo-guard] Variantkartan och familjekartan sager olika saker. ' +
'Snabbvagen ar avstangd tills snippets/on-bogo-variant-map.liquid genererats om. ' +
'Vakten fungerar fortfarande, via produkt-id pa svaret.');
  }
function visa(text) {
var el = document.getElementById('on-bogo-note');
if (!el) {
el = document.createElement('div');
el.id = 'on-bogo-note';
el.setAttribute('role', 'status');
el.setAttribute('aria-live', 'polite');
document.body.appendChild(el);
}
el.textContent = text;
el.hidden = false;
clearTimeout(el._t);
el._t = setTimeout(function () { el.hidden = true; }, 7000);
  }
var origFetch = window.fetch;
function hamtaKorg() {
return origFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
/* Plockar ut variant-id ur ett /cart/add-anrop. Temat skickar bade JSON och
FormData beroende pa yta, sa bagge maste tackas. */
  function idIAnrop(init) {
var b = init && init.body;
if (!b) return [];
try {
if (typeof b === 'string') {
 var j = JSON.parse(b);
 if (j.items) return j.items.map(function (i) { return i.id; });
 if (j.id) return [j.id];
 return [];
}
if (typeof FormData !== 'undefined' && b instanceof FormData) {
 var ut = [];
 b.forEach(function (v, k) { if (k === 'id' || /items\[\d+\]\[id\]/.test(k)) ut.push(v); });
 return ut;
}
if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) {
 return b.getAll('id');
}
} catch (e) { /* okant format -> vi lagger oss inte i */ }
return [];
  }
/* Finns redan en rad ur samma familj pa MOTSATT sida? Radernas familj avgors av
product_id, sa svaret pavarkas inte av varianttabellens skick. */
  function krock(sida, key, cart) {
var rader = (cart && cart.items) || [];
for (var i = 0; i < rader.length; i++) {
var m = P[String(rader[i].product_id)];
if (m && m.key === key && m.sida !== sida) return rader[i];
}
return null;
  }
/* Samma felform som Shopify sjalv returnerar nar ett tillagg nekas, sa temat
visar vart meddelande i sin egen felruta i stallet for en generisk text. */
  function nekat(text) {
return new Response(
JSON.stringify({ status: 422, message: 'Cart Error', description: text }),
{ status: 422, statusText: 'Unprocessable Entity', headers: { 'Content-Type': 'application/json' } }
);
  }
function angraRad(key) {
return origFetch('/cart/change.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({ id: key, quantity: 0 })
});
  }
window.fetch = function (input, init) {
var url = (typeof input === 'string') ? input : (input && input.url) || '';
if (url.indexOf('/cart/add') === -1) return origFetch.apply(this, arguments);
var self = this, args = arguments;
var ids = idIAnrop(init);
var kanda = ids.filter(function (id) { return V[String(id)]; });
/* Korgen hamtas om vid VARJE forsok, den cachas inte. En cache invalideras bara
av vara egna tillagg och av cart:update, sa en andring fran ett annat hall
(annan flik, en app, ett direkt API-anrop) skulle gora cachen inaktuell och
blockera en helt legitim produkt. Ett falskt block ar ett tappat kop. */
if (kanda.length) {
return hamtaKorg().then(function (cart) {
 for (var i = 0; i < kanda.length; i++) {
   var m = V[String(kanda[i])];
   if (krock(m.sida, m.key, cart)) { visa(S.mix); return nekat(S.mix); }
 }
 return origFetch.apply(self, args);
})['catch'](function () {
 /* Gar uppslaget fel slapper vi igenom. Hellre ett obevakat tillagg an ett
    blockerat kop pa grund av en natverksmiss. */
 return origFetch.apply(self, args);
});
}
/* Varianten fanns inte i cachen. Da slapper vi igenom och kontrollerar pa
SVARET, dar product_id finns med. Skapade tillagget en blandning angras
raden och kunden far samma besked. Langsammare, aldrig fel. */
return origFetch.apply(self, args).then(function (res) {
if (!res || !res.ok) return res;
return res.clone().json().then(function (data) {
 var lagda = (data && data.items) ? data.items : (data && data.id ? [data] : []);
 var traff = null;
 for (var i = 0; i < lagda.length; i++) {
   if (P[String(lagda[i].product_id)]) { traff = lagda[i]; break; }
 }
 if (!traff) return res;
 var m = P[String(traff.product_id)];
 return hamtaKorg().then(function (cart) {
   if (!krock(m.sida, m.key, cart)) return res;
   return angraRad(traff.key).then(function () {
     visa(S.mix);
     return nekat(S.mix);
   });
 });
})['catch'](function () { return res; });
});
  };
/* --- Ta bort rader fran en kampanj som tagit slut ---------------------- */
var stadar = false;
function stadaUtgangna() {
/* Ar alla par aktiva finns inget att stada och vi ror inte natverket alls. */
if (!harInaktiv || stadar) return;
stadar = true;
hamtaKorg().then(function (cart) {
var doda = (cart.items || []).filter(function (i) {
 var m = P[String(i.product_id)];
 return m && m.sida === 'offer' && m.p.active === false;
});
if (!doda.length) { stadar = false; return null; }
var namn = doda[0].product_title;
 /* Rabatterade rader listas av Shopify som FLERA poster med SAMMA line key
  (en till fullpris, en gratis). Utan dedupning skickar vi samma borttagning
  tva ganger och den andra traffar en rad som inte langre finns. */
var nycklar = [], sedda = {};
doda.forEach(function (rad) { if (!sedda[rad.key]) { sedda[rad.key] = 1; nycklar.push(rad.key); } });
 /* En rad i taget pa line key. Radnummer pekar fel sa fort korgen andras. */
var kedja = Promise.resolve();
nycklar.forEach(function (key) { kedja = kedja.then(function () { return angraRad(key); }); });
 return kedja.then(function () {
 /* Kontrollera att det faktiskt ar borta i stallet for att lita pa svaren. */
 return hamtaKorg();
}).then(function (farsk) {
 var kvar = (farsk.items || []).filter(function (i) {
   var m = P[String(i.product_id)];
   return m && m.sida === 'offer' && m.p.active === false;
 });
 stadar = false;
 visa(String(S.ended).split('[p]').join(namn));
 /* Temats form: detail.data maste finnas, annars kraschar cart-lyssnarna. */
 document.dispatchEvent(new CustomEvent('cart:update', {
   bubbles: true,
   detail: {
     resource: farsk,
     sourceId: 'on-bogo-guard',
     data: { source: 'on-bogo-guard', itemCount: farsk.item_count, sections: null }
   }
 }));
 if (kvar.length) setTimeout(stadaUtgangna, 400);   /* ett forsok till */
});
})['catch'](function () { stadar = false; });
  }
document.addEventListener('cart:update', function (e) {
if (e && e.detail && e.detail.data && e.detail.data.source === 'on-bogo-guard') return;
setTimeout(stadaUtgangna, 0);
  });
setTimeout(stadaUtgangna, 0);
})();

